import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFeatureAccess, FEATURE_ROUTE_MAP, FEATURE_LABELS } from '../context/FeatureAccessContext';
import { Lock, Sparkles, ArrowLeft, Star, Crown } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const tb = { fontFamily: "'Tiro Bangla', serif" };
const toBnNum = (n) => String(n).replace(/[0-9]/g, d => '০১২৩৪৫৬৭৮৯'[d]);

const INSPIRE_MESSAGES = [
    "সাফল্যের পথে প্রতিটি পদক্ষেপ গুরুত্বপূর্ণ। এই section unlock করে নিজের সম্ভাবনা প্রকাশ করো!",
    "তুমি যে শুরু করেছো সেটাই সবচেয়ে বড় সাহস! আরো এগিয়ে যেতে এই feature unlock করো।",
    "বড় স্বপ্ন দেখো, বড় শেখো! এই section তোমার English-কে নতুন উচ্চতায় নিয়ে যাবে।",
    "প্রতিটি বড় যাত্রা শুরু হয় একটি ছোট পদক্ষেপ দিয়ে। তুমি পারবে!",
];

const FeatureGate = ({ path, children }) => {
    const { isLocked, loading } = useFeatureAccess();
    const navigate = useNavigate();
    const featureKey = FEATURE_ROUTE_MAP[path];
    const feature = FEATURE_LABELS?.[featureKey];
    const msg = INSPIRE_MESSAGES[Math.floor(Math.random() * INSPIRE_MESSAGES.length)];
    const [price, setPrice] = useState(135);

    useEffect(() => {
        axios.get(`${API}/pricing-config`).then(r => {
            const p = r.data.premium_weekly_price || r.data?.config?.premium_weekly_price;
            if (p) setPrice(p);
        }).catch(() => {});
    }, []);

    if (loading) return children;
    if (!featureKey || !isLocked(featureKey)) return children;

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="feature-locked-page">
            <div className="w-full max-w-sm text-center">
                <div className="relative inline-flex mb-6">
                    <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center shadow-lg">
                        <Lock className="w-9 h-9 text-purple-400" />
                    </div>
                    <div className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-amber-400 flex items-center justify-center shadow-md">
                        <Star className="w-3.5 h-3.5 text-white" />
                    </div>
                </div>

                <h2 className="text-xl font-bold text-gray-800 mb-1" style={tb}>
                    {feature ? `${feature.en} (${feature.bn})` : 'এই Feature'} Lock আছে
                </h2>
                <p className="text-sm text-gray-400 mb-5" style={tb}>
                    এই feature-টি এখনো আপনার জন্য unlock করা হয়নি
                </p>

                <div className="bg-gradient-to-br from-purple-50 via-pink-50 to-violet-50 rounded-3xl p-5 mb-5 border border-purple-100 shadow-sm">
                    <div className="flex items-start gap-3 text-left">
                        <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center shrink-0 mt-0.5">
                            <Sparkles className="w-4 h-4 text-white" />
                        </div>
                        <p className="text-sm text-gray-700 leading-relaxed" style={tb}>
                            "{msg}"
                        </p>
                    </div>
                </div>

                <div className="p-4 rounded-2xl bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-100 mb-4">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <Crown className="w-4 h-4 text-purple-600" />
                        <span className="font-bold text-purple-700" style={tb}>Premium — {toBnNum(price)} টাকা/সপ্তাহ</span>
                    </div>
                    <p className="text-[10px] text-purple-500" style={tb}>সব ফিচার আনলক, সীমাহীন শেখা</p>
                </div>

                <a
                    href="mailto:info@bakkoshilpi.com?subject=Premium Unlock&body=আমি Premium unlock করতে চাই।"
                    className="w-full py-3 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-sm text-center hover:opacity-90 transition-all shadow-lg block mb-4"
                    data-testid="feature-gate-unlock-btn"
                    style={tb}
                >
                    <Sparkles className="w-4 h-4 inline mr-1.5" />এখনই Unlock করো
                </a>

                <button onClick={() => navigate('/dashboard')}
                    className="inline-flex items-center gap-2 text-purple-600 text-sm font-medium hover:text-purple-800 transition-colors"
                    style={tb}>
                    <ArrowLeft className="w-4 h-4" />
                    Dashboard-এ ফিরে যান
                </button>
            </div>
        </div>
    );
};

export default FeatureGate;
